import { KYCAPI } from '../../../constants/global';
import type { IKycFaceResponse, IKycMatchResponse, IKycPvcResponse } from '../../../interface/action/kyc';
import { kycType } from '../../types';
import * as utils from '../utils';
import type { IResponse } from './election';

export const validatePvc_Kyc = ({
	data,
	onSuccess,
	onFailure,
}: IResponse<IKycPvcResponse> & {
	data: FormData;
}) =>
	utils.httpUploadMediaMethod({
		apiData: {
			customurl: `${KYCAPI}/kyc/id/check`,
			url: '',
			header: utils.headerMultipart(),
			data,
		},
		actionType: kycType.validatePvc_Kyc,
		onSuccess,
		onFailure,
		auth: true,
	});

export const uploadFace_Kyc = ({
	data,
	onSuccess,
	onFailure,
}: IResponse<IKycFaceResponse> & {
	data: FormData;
}) =>
	utils.httpUploadMediaMethod({
		apiData: {
			customurl: `${KYCAPI}/kyc/face/upload`,
			url: '',
			header: utils.headerMultipart(),
			data,
		},
		actionType: kycType.uploadFace_Kyc,
		onSuccess,
		onFailure,
		auth: true,
	});

export const matchFace_Kyc = ({
	data,
	faceId,
	onSuccess,
	onFailure,
}: IResponse<IKycMatchResponse> & {
	data: FormData;
	faceId: string;
}) =>
	utils.httpUploadMediaMethod({
		apiData: {
			customurl: `${KYCAPI}/kyc/face/match/${faceId}`,
			url: '',
			header: utils.headerMultipart(),
			data,
		},
		actionType: kycType.matchFace_Kyc,
		onSuccess,
		onFailure,
		auth: true,
	});

export const uploadVideoFace_Kyc = ({
	data,
	onSuccess,
	onFailure,
}: IResponse<IKycFaceResponse> & {
	data: FormData;
}) =>
	utils.httpUploadMediaMethod({
		apiData: {
			customurl: `${KYCAPI}/kyc/face/upload-video`,
			url: '',
			header: utils.headerMultipart(),
			data,
		},
		actionType: kycType.uploadVideoFace_Kyc,
		onSuccess,
		onFailure,
		auth: true,
	});

export const matchVideoFace_Kyc = ({
	data,
	faceId,
	onSuccess,
	onFailure,
}: IResponse<IKycMatchResponse> & {
	data: FormData;
	faceId: string;
}) =>
	utils.httpUploadMediaMethod({
		apiData: {
			customurl: `${KYCAPI}/kyc/face/match-video/${faceId}`,
			url: '',
			header: utils.headerMultipart(),
			data,
		},
		actionType: kycType.matchVideoFace_Kyc,
		onSuccess,
		onFailure,
		auth: true,
	});
